<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3 v-show="tipoReporte == 'P'">
          {{
            `Reporte de efectividad por ${
              tipoPersona == "S" ? "supervisores" : "vendedores"
            }`
          }}
        </h3>
        <h3 v-show="tipoReporte == 'D'">
          Reporte de efectividad global detallada
        </h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button
            type="button"
            @click="mostrarHistoricos"
            class="btn-secondary"
          >
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button
            type="button"
            @click="exportarDocumento('E')"
            class="btn-success"
          >
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
          <button
            type="button"
            @click="exportarDocumento('P')"
            class="btn-danger"
          >
            <i class="fa fa-file-pdf-o"></i><span>PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label>
                <input v-model="form.tipoFecha" type="radio" value="H" />
                <span>Hoy</span>
              </label>
              <label>
                <input v-model="form.tipoFecha" type="radio" value="A" />
                <span>Ayer</span>
              </label>
              <label>
                <input v-model="form.tipoFecha" type="radio" value="P" />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaDesde"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Desde:</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaHasta"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Hasta:</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div
              class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': !administraTodasBodegas }"
            >
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="optionsBodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal:</label>
              </div>
            </div>
          </div>
          <div
            v-show="tipoPersona == 'S' || tipoReporte == 'D'"
            :class="'col-xs-12 col-md-' + (tipoReporte == 'D' ? '6' : '8')"
          >
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @search="onSearchUsuarios"
                  @input="inputUsuarios"
                  label="nombre"
                  placeholder="Seleccione..."
                  :options="optionsUsuarios"
                  id="usuarios"
                  v-model="selectedUsuarios"
                  multiple
                ></v-select>
                <label for="usuarios">Supervisores:</label>
              </div>
            </div>
          </div>
          <div
            v-show="tipoPersona == 'V' || tipoReporte == 'D'"
            :class="'col-xs-12 col-md-' + (tipoReporte == 'D' ? '6' : '8')"
          >
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @search="onSearchVendedores"
                  @input="inputVendedores"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="optionsVendedores"
                  id="vendedores"
                  v-model="selectedVendedores"
                  multiple
                ></v-select>
                <label for="vendedores">Vendedores:</label>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputRangoVentas"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="optionsRangoVentas"
                  id="rangoVentas"
                  v-model="selectedRangoVentas"
                ></v-select>
                <label for="rangoVentas">Ventas:</label>
              </div>
            </div>
          </div>
          <div class="col-md-1" v-show="selectedRangoVentas != null">
            <div class="form-field">
              <input-field
                placeholder="Digite un valor..."
                id="rangoVentas"
                name="rangoVentas"
                v-model="form.rangoVentas"
              >
              </input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="registros.length > 0">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div
              v-show="nombreBodega != null && nombreBodega != ''"
              class="form-field"
            >
              <h6>{{ `SUCURSAL: ${nombreBodega}` }}</h6>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="table-responsive">
              <table class="table--bordered">
                <thead>
                  <tr>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      {{ tipoReporte != "D" ? "#" : "Supervisor" }}
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      {{
                        tipoPersona == "S" && tipoReporte != "D"
                          ? "Supervisor"
                          : "Vendedor"
                      }}
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      Sucursal
                    </th>
                    <th
                      style="font-size: 10px; background-color: #f3f2f2"
                      v-for="(diaSemana, index) in diasSemana"
                      :key="
                        index.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'dia'
                      "
                    >
                      <span>{{ diaSemana.nombre_dia }}</span>
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      Ventas
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      Total
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      Dev.
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      Cobro
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      No Cobro
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      Valor
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      % Cobrada
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      % Dev.
                    </th>
                    <th style="font-size: 10px; background-color: #f3f2f2">
                      % No Cobro
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(registro, index2) in registros"
                    :key="
                      index2.toString() +
                      moment(new Date()).format('YYYYMMDDHHmmss') +
                      'reg'
                    "
                    :style="
                      registro.es_total ? 'background-color:#F3F2F2;' : ''
                    "
                  >
                    <td style="font-size: 10px">
                      {{
                        tipoReporte != "D"
                          ? index2 + 1
                          : registro.supervisor_nombre
                      }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.persona_nombre }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.bodega_nombre }}
                    </td>
                    <td
                      style="font-size: 10px"
                      v-for="(detalle, index3) in registro.detalles"
                      :key="
                        index3.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'det'
                      "
                    >
                      <span>{{ detalle.ventas }}</span>
                    </td>
                    <td style="font-size: 10px">{{ registro.total_ventas }}</td>
                    <td style="font-size: 10px">
                      {{ registro.total_valores }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.total_devoluciones }}
                    </td>
                    <td style="font-size: 10px">{{ registro.total_cobros }}</td>
                    <td style="font-size: 10px">
                      {{ registro.total_no_cobros }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.total_valores_cobrados }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.porcentaje_cobrado }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.porcentaje_devolucion }}
                    </td>
                    <td style="font-size: 10px">
                      {{ registro.porcentaje_no_cobro }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="font-size: 10px; background-color: #f3f2f2"
                      colspan="3"
                    >
                      <b>{{
                        `T. VENTAS ${
                          tipoPersona == "S" ? "SUPERVISORES:" : "VENDEDORES:"
                        }`
                      }}</b>
                    </td>
                    <td
                      style="font-size: 10px; background-color: #f3f2f2"
                      v-for="(diaSemana, index4) in diasSemana"
                      :key="
                        index4.toString() +
                        moment(new Date()).format('YYYYMMDDHHmmss') +
                        'dia_total'
                      "
                    >
                      <b>{{ diaSemana.ventas }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ totalVentas }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ totalValores }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ totalDevoluciones }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ totalCobros }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ totalNoCobros }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ totalValoresCobrados }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ porcentajeCobrado }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ porcentajeDevolucion }}</b>
                    </td>
                    <td style="font-size: 10px; background-color: #f3f2f2">
                      <b>{{ porcentajeNoCobrado }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="historicos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <reportes-historicos-excel
        :tipoReporte="tipo_reporte_historico"
      ></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    tipoPersona: {
      required: true,
    },
    bodegas: {
      required: true,
    },
    administraTodasBodegas: {
      type: Boolean,
      required: true,
    },
    idBodegaUsuario: {
      required: true,
    },
    tipoReporte: {
      required: false,
      default: "P",
    },
  },
  data: function () {
    return {
      moment: moment,
      registros: [],
      selectedUsuarios: [],
      selectedVendedores: [],
      selectedRangoVentas: null,
      optionsUsuarios: [],
      optionsVendedores: [],
      optionsRangoVentas: [
        { value: "ma", descripcion: "Mayores a" },
        { value: "me", descripcion: "Menores a" },
      ],
      selectedBodega: null,
      nombreBodega: "",
      optionsBodegas: [],
      diasSemana: [],
      totalVentas: 0,
      totalValores: 0,
      totalDevoluciones: 0,
      totalCobros: 0,
      totalNoCobros: 0,
      totalValoresCobrados: 0,
      porcentajeDevolucion: 0,
      porcentajeCobrado: 0,
      porcentajeNoCobrado: 0,
      tipo_reporte_historico: "egb",
      form: {
        tipoFecha: "P",
        fechaDesde: "",
        fechaHasta: "",
        idsUsuarios: [],
        idsVendedores: [],
        idBodega: null,
        tipoRangoVentas: null,
        rangoVentas: 0,
      },
    };
  },
  methods: {
    onSearchUsuarios: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.optionsUsuarios = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = "";
      urlApi = `${url}/search/usuarios?search=${search}&tipo=S`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    onSearchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.optionsVendedores = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = "";
      urlApi = `${url}/search/vendedores?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    inputUsuarios: function () {
      this.form.idsUsuarios.splice(0, this.form.idsUsuarios.length);
      this.form.idsUsuarios = this.selectedUsuarios.map(
        (usuario) => usuario.id
      );
    },
    inputVendedores: function () {
      this.form.idsVendedores.splice(0, this.form.idsVendedores.length);
      this.form.idsVendedores = this.selectedVendedores.map(
        (vendedor) => vendedor.id
      );
    },
    inputBodega: function () {
      this.form.idBodega = null;
      if (this.selectedBodega != null)
        this.form.idBodega = this.selectedBodega.id;
    },
    inputRangoVentas: function () {
      this.form.tipoRangoVentas = null;
      if (this.selectedRangoVentas != null)
        this.form.tipoRangoVentas = this.selectedRangoVentas.value;
    },
    validandoFiltros: function () {
      //Validando las fechas
      if (this.form.tipoFecha == "P") {
        if (this.form.fechaDesde == null || this.form.fechaHasta == null) {
          swal("Aviso", "Las fechas son requeridas", "warning");
          return false;
        }
        let desde = new Date(this.form.fechaDesde + " 00:00:00");
        let hasta = new Date(this.form.fechaHasta + " 00:00:00");
        if (desde == "Invalid Date" || hasta == "Invalid Date") {
          swal("Aviso", "Debe ingresar correctamente las fechas", "warning");
          return false;
        }
      }
      if (this.form.idBodega === null) {
        swal("Aviso", "La sucursal es requerida", "warning");
        return false;
      }
      return true;
    },
    exportarDocumento: function (tipo) {
      if (!this.validandoFiltros()) return;
      let urlApi = `${url}/reporte-efectividad-persona/consultar/${tipo}/${
        this.tipoPersona
      }/${this.tipoReporte}${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    consultar: function () {
      if (!this.validandoFiltros()) return;
      let urlApi = `${url}/reporte-efectividad-persona/consultar/C/${this.tipoPersona}/${this.tipoReporte}`;
      axios
        .post(urlApi, this.form)
        .then((response) => {
          let data = response.data;
          this.nombreBodega = data.nombreBodega;
          this.diasSemana.splice(0, this.diasSemana.length);
          this.diasSemana = [...data.diasSemana];
          this.registros.splice(0, this.registros.length);
          this.registros = [...data.registros];
          this.totalVentas = data.totalVentas;
          this.totalValores = data.totalValores;
          this.totalDevoluciones = data.totalDevoluciones;
          this.totalCobros = data.totalCobros;
          this.totalNoCobros = data.totalNoCobros;
          this.totalValoresCobrados = data.totalValoresCobrados;
          this.porcentajeDevolucion = data.porcentajeDevolucion;
          this.porcentajeCobrado = data.porcentajeCobrado;
          this.porcentajeNoCobrado = data.porcentajeNoCobrado;
        })
        .catch((error) => {
          swal("Error", "No se pudo consultar el reporte", "error");
        });
    },
    mostrarHistoricos: function () {
      if (this.tipoReporte === "D") this.tipo_reporte_historico = "egd";
      else if (this.tipoPersona === "S") this.tipo_reporte_historico = "es";
      else this.tipo_reporte_historico = "ev";

      this.$modal.show("historicos");
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
  },
  mounted: function () {
    //Seteando fechas por defecto
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    let hasta = new Date();
    this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
    this.form.fechaHasta = moment(hasta).format("YYYY-MM-DD");
    //Seteando bodegas
    if (this.administraTodasBodegas) {
      const todasBodegas = { id: "T", descripcion: "TODAS" };
      this.optionsBodegas = [todasBodegas, ...this.bodegas];
      this.selectedBodega = todasBodegas;
      this.form.idBodega = todasBodegas.id;
    } else {
      for (let i = 0; i < this.bodegas.length; i++) {
        if (this.idBodegaUsuario == this.bodegas[i].id) {
          this.optionsBodegas.push(this.bodegas[i]);
          this.selectedBodega = this.bodegas[i];
          this.form.idBodega = this.bodegas[i].id;
          break;
        }
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadPersona.vue